import styled from "@emotion/styled";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";

const Wrapper = styled.div`
  background-color: ${props => props.theme.colors.white};
  overflow: hidden;
  border-radius: 20px;
  padding: 0;
`;

const AccordionStyled = styled(Accordion)`
  font-family: "SF Pro";
  box-shadow: none;

  .icon-accordion {
    background-color: ${props => props.theme.colors.background};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: ${p => p.theme.space[7]}px;
    height: ${p => p.theme.space[7]}px;

    @media (min-width: ${props => props.theme.screenSizes.mdMax}) {
      width: 48px;
      height: 48px;
    }
  }

  &.Mui-expanded {
    margin: 0;

    .icon-accordion {
      background-color: ${props => props.theme.colors.black};
      border-radius: 50%;
      color: ${props => props.theme.palette.white};
      transform: rotate(45deg);
    }
  }

  &:before {
    height: 3px;
    background-color: ${props => props.theme.colors.background};
  }

  &:not(:first-of-type).Mui-expanded:before {
    background-color: ${props => props.theme.colors.background};
    display: block !important;
    height: 3px;
    opacity: 1;
  }
`;

const Summary = styled(AccordionSummary)`
  min-height: 0;
  display: flex;
  align-items: center;
  transition: background-color 0.3s ease-in-out;

  padding: 18px 20px;

  @media (min-width: ${props => props.theme.screenSizes.mdMax}) {
    padding: ${p => p.theme.space[7]}px 60px;
  }

  & .MuiAccordionSummary-content {
    color: ${props => props.theme.colors.secondary.title};
    font-weight: 500;
    font-size: 20px;
    margin: 0;
    padding-right: ${p => p.theme.space[5]}px;

    @media (min-width: ${props => props.theme.screenSizes.mdMax}) {
      font-size: 28px;
    }
  }

  & .MuiAccordionSummary-content.Mui-expanded {
    margin: 0;
  }
`;

const Details = styled(AccordionDetails)`
  color: ${props => props.theme.colors.secondary.gray};
  display: block;
  font-family: "Inter";
  padding: 0 50px 18px 20px;
  padding-bottom: 18px;
  font-size: 14px;
  line-height: 1.5;
  transition: max-height 0.3s ease-in-out;

  @media (min-width: ${props => props.theme.screenSizes.mdMax}) {
    line-height: 1.4;
    font-size: 20px;
    padding-bottom: ${p => p.theme.space[7]}px;
    padding-left: 60px;
  }
`;

export { Wrapper, AccordionStyled, Summary, Details };
